<template>
  <div class="col-12 bg-white q-pa-sm">
    <div class="col-12 row">
      <q-icon
        color="red"
        size="md"
        class="q-px-sm"
        name="fas fa-map-marker-alt"
      />
      <div class="col-grow">
        <div style="font-weight: bold">
          {{ formatedName }}
        </div>
        <div>
          {{ formatedAddress }}
        </div>
        <div style="color: gray">
          {{ formatedLocation }}
        </div>
        <div style="font-weight: bold">Contact Information</div>
        <div>
          {{ formatedContact }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ShippingType } from "@/entities/order/order";
export default {
  name: "ShippingAddress",
  data() {
    return {
      // formatedName: "Test",
      // formatedAddress: "168/22 moo 5 lumpini villa - - Pak Kret Amphoe Pak Kret Nonthaburi 11120",
      // formatedLocation: "location: 13.909,100.502",
      // formatedContact: "tor1 intanon1 +66823327227 tor@avilon.co",
    };
  },
  computed: {
    shippingType() {
      return this.$store.state["checkout"]["shippingType"];
    },
    shippingAddress() {
      return this.$store.state["checkout"]["shippingAddress"];
    },
    formatedName() {
      if (this.shippingAddress) {
        return this.shippingAddress.name;
      }
      return "";
    },
    formatedAddress() {
      if (this.shippingAddress) {
        const shippingAddress = this.shippingAddress;
        return `${shippingAddress.address} ${
          shippingAddress.subDistrict || ""
        } ${shippingAddress.district || ""} ${shippingAddress.province} ${
          shippingAddress.postcode
        }`;
      }
      return "";
    },
    formatedLocation() {
      if (this.shippingAddress) {
        const shippingAddress = this.shippingAddress;
        return `location: ${shippingAddress.location.lat} ${shippingAddress.location.lng}`;
      }
      return "";
    },
    formatedContact() {
      if (this.shippingAddress) {
        const shippingAddress = this.shippingAddress;
        let output = "";
        if (shippingAddress.firstname) {
          output += `${shippingAddress.firstname} `;
        }
        if (shippingAddress.phone) {
          output += `${shippingAddress.phone}  `;
        }
        if (shippingAddress.email) {
          output += ` ${shippingAddress.email} `;
        }
        return output;
      }
      return "";
    },
    branch() {
      return this.$store.state["branch"]["branch"];
    },
  },
  watch: {
    branch: {
      handler: function (value) {
        console.log("watch:", value);
        if (this.shippingType === ShippingType.PICKUP) {
          this.updateShippingAddress();
        }
      },
    },
  },
  methods: {
    async updateShippingAddress() {
      await this.$store.dispatch(
        "checkout/setShippingType",
        ShippingType.PICKUP
      );
      await this.$store.dispatch("checkout/getCost");
    },
  },
};
</script>
